/**
 * @module Experince/Product-Selector
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import {
  LineDeivceDetails,
  lineTypeEnum,
  TileIdAndLengthToCreateLine,
} from '@experience/shop/product-selector/interfaces/product-selector.interface';

export class CreateDeleteUpdateTileModel {
  /**
   * Function used to extract the basic details
   */
  public static createTile(
    tileIdDetails: TileIdAndLengthToCreateLine,
    lineType: lineTypeEnum,
    noPlanNeeded: boolean
  ): LineDeivceDetails {
    return lineType === (lineTypeEnum.LINE || lineTypeEnum.EXISTING)
      ? this.createLineTile(tileIdDetails, lineType)
      : this.createNonLineTile(tileIdDetails, lineType, noPlanNeeded);
  }

  /**
   * Function used to create line tile
   */
  public static createLineTile(
    tileIdDetails: TileIdAndLengthToCreateLine,
    lineType: lineTypeEnum
  ): LineDeivceDetails {
    return {
      tileId: tileIdDetails.tileId,
      lineTileType: lineType,
      currentLineNumber: tileIdDetails.currentLength,
      selectedDevice: {},
      isLineSetupCompleted: false,
      deviceDetails: {},
      plansFromCart: {
        nickName: 'Line' + tileIdDetails.currentLength.toString(),
      },
    };
  }
  // @TODO remove follwing function
  /**
   * Function used to create non line tile
   */
  public static createNonLineTile(
    tileIdDetails: TileIdAndLengthToCreateLine,
    lineType: lineTypeEnum,
    noPlanNeeded: boolean
  ): LineDeivceDetails {
    return {
      tileId: tileIdDetails.tileId,
      lineTileType: lineType,
      currentLineNumber: tileIdDetails.currentLength,
      noPlanNeeded: noPlanNeeded,
      isLineSetupCompleted: false,
      disableIDontNeedCheckbox: noPlanNeeded,
      selectedDevice: {},
      deviceDetails: {},
      plansFromCart: {
        nickName: 'Device',
      },
    };
  }
  /**
   * Function used to update plan selection
   * @param {LineDeivceDetails} currentLineDetails
   * @param {boolean} noPlanNeeded
   * @returns {LineDeivceDetails}
   */
  public static updateNoPlanNeeded(
    currentLineDetails: LineDeivceDetails,
    noPlanNeeded: boolean
  ): LineDeivceDetails {
    const fucusedTileDetails = currentLineDetails;
    fucusedTileDetails.noPlanNeeded = noPlanNeeded;
    fucusedTileDetails.plansFromCart.nickName = 'Device';
    fucusedTileDetails.selectedPlanId = null;
    return fucusedTileDetails;
  }
}
